import React from 'react';
import { FormField, SearchField } from '@/components/custom/erp';
import { accountSearchColumns, QUERY_KEYS } from '@/constants';
import { AccountModel } from '@/types/schemas';
import { Label } from '@/components/ui/label';
import { FormMode } from '@/types/form';

interface FormDialogProps {
  formMode: FormMode;
  account: AccountModel | null;
  setAccount: (account: AccountModel) => void;
}

const FormDialog: React.FC<FormDialogProps> = ({ formMode, account, setAccount }) => {
  const isViewMode = formMode === 'view';

  return (
    <div className='max-h-[calc(100vh-150px)] overflow-y-auto'>
      <div className='p-4 md:p-6'>
        <div className='flex flex-col gap-y-4 md:gap-y-6'>
          <div className='space-y-4 md:space-y-6'>
            <div className='flex flex-col sm:flex-row sm:items-center'>
              <Label className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>Mã nhập xuất</Label>
              <FormField
                type='text'
                name='ma_nx'
                className='w-full'
                disabled={formMode === 'view' || formMode === 'edit'}
              />
            </div>

            <div className='flex flex-col sm:flex-row sm:items-center'>
              <Label className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>Tên nhập xuất</Label>
              <FormField type='text' name='ten_nx' className='w-full' disabled={isViewMode} />
            </div>

            <div className='flex flex-col sm:flex-row sm:items-center'>
              <Label className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>Tên khác</Label>
              <FormField type='text' name='ten_nx2' disabled={isViewMode} />
            </div>

            <div className='flex flex-col sm:flex-row sm:items-center'>
              <Label className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>Tài khoản</Label>
              <SearchField<AccountModel>
                type='text'
                displayRelatedField={'name'}
                columnDisplay={'code'}
                searchEndpoint={`/${QUERY_KEYS.TAI_KHOAN}`}
                searchColumns={accountSearchColumns}
                dialogTitle='Danh mục tài khoản'
                value={account?.code || ''}
                relatedFieldValue={account?.name || ''}
                onRowSelection={setAccount}
                disabled={isViewMode}
                className='w-100'
              />
            </div>

            <div className='flex flex-col sm:flex-row sm:items-center'>
              <Label htmlFor='status' className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>
                Trạng thái
              </Label>
              <FormField
                id='status'
                type='select'
                name='status'
                className='w-full'
                disabled={isViewMode}
                options={[
                  { value: '1', label: '1. Còn sử dụng' },
                  { value: '0', label: '0. Không sử dụng' }
                ]}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FormDialog;
